module["exports"] = [
  "Apto. ###",
  "Sobrado ##",
  "Casa #",
  "Lote ##",
  "Quadra ##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/secondary_address.js
// module id = 1238
// module chunks = 0